

export default {
  categorie_articles: []
}
